import { render, staticRenderFns } from "./addPayType.vue?vue&type=template&id=bbf48db6&"
import script from "./addPayType.vue?vue&type=script&lang=js&"
export * from "./addPayType.vue?vue&type=script&lang=js&"
import style0 from "./addPayType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbf48db6')) {
      api.createRecord('bbf48db6', component.options)
    } else {
      api.reload('bbf48db6', component.options)
    }
    module.hot.accept("./addPayType.vue?vue&type=template&id=bbf48db6&", function () {
      api.rerender('bbf48db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/components/addPayType.vue"
export default component.exports